
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M3.813 3.813a8.75 8.75 0 1112.374 12.374A8.75 8.75 0 013.813 3.813zM10 2.75a7.25 7.25 0 100 14.5 7.25 7.25 0 000-14.5z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M10.315 9.677a.75.75 0 01.001 1.061l-4.052 4.057a.75.75 0 11-1.061-1.06l4.052-4.057a.75.75 0 011.06 0z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M12.638 4.94a8.204 8.204 0 011.754 0 .75.75 0 01.665.66c.372 3.279-1.17 5.701-3.02 7.07-.918.68-1.932 1.117-2.86 1.268-.89.146-1.878.05-2.523-.596-.485-.485-.656-1.166-.655-1.822 0-.667.176-1.398.487-2.11a7.677 7.677 0 013.604-3.764.75.75 0 01.99.318l.266.494.737-1.172a.75.75 0 01.555-.346zm.515 1.462L11.93 8.346a.75.75 0 01-1.295-.044l-.512-.952a6.199 6.199 0 00-2.262 2.659c-.248.569-.361 1.095-.362 1.513 0 .428.113.658.216.76.142.142.523.29 1.22.176.663-.108 1.458-.437 2.21-.994 1.371-1.015 2.525-2.729 2.465-5.07-.152-.003-.305 0-.457.008z","clip-rule":"evenodd"}})])
          )
        }
      }
    